import { ExpectedSubscriptionOfPlanification } from '@sdk/contracts';
import { MultiSegmentProgress } from 'react-multi-segment-progress';
import { useTheme } from 'styled-components';

import {
  CoursesPlanificationWrapper,
  ColumnsContainer,
  ScrollableContent,
  CoursesColumn,
  CourseNameItem,
  ProgressBarItem,
  ProgressWrapper
} from './CoursesPlanificationGraph.styles';

type Props = {
  expectedSubscriptionsOfPlanification: ExpectedSubscriptionOfPlanification[];
};

export const CoursesPlanificationGraph: React.FC<Props> = ({
  expectedSubscriptionsOfPlanification
}) => {
  const { colors } = useTheme();

  const getColor = (expectedSubscription: ExpectedSubscriptionOfPlanification) => {
    const diff = expectedSubscription.expectedProgress - expectedSubscription.actualProgress;
    if (diff <= 0) return colors.green6;
    if (diff <= 10) return colors.orange6;
    return colors.red6;
  };

  if (!expectedSubscriptionsOfPlanification) return null;
  return (
    <CoursesPlanificationWrapper>
      <ScrollableContent>
        <ColumnsContainer>
          <CoursesColumn>
            {expectedSubscriptionsOfPlanification.map(expectedSubscription => (
              <CourseNameItem
                key={expectedSubscription.subscription._id}
                title={expectedSubscription.subscription.course.name}>
                {expectedSubscription.subscription.course.name}
              </CourseNameItem>
            ))}
          </CoursesColumn>

          <CoursesColumn>
            {expectedSubscriptionsOfPlanification.map(expectedSubscription => (
              <ProgressBarItem key={expectedSubscription.subscription._id}>
                <ProgressWrapper>
                  <MultiSegmentProgress
                    segments={[
                      {
                        id: 'progress',
                        percentage: expectedSubscription.actualProgress,
                        color: getColor(expectedSubscription)
                      },
                      {
                        id: 'expected',
                        percentage:
                          expectedSubscription.expectedProgress -
                          expectedSubscription.actualProgress,
                        color: colors.black3
                      }
                    ]}
                    showTooltips={false}
                    height={8}
                    borderRadius={8}
                    backgroundColor={colors.white}
                  />
                </ProgressWrapper>
              </ProgressBarItem>
            ))}
          </CoursesColumn>
        </ColumnsContainer>
      </ScrollableContent>
    </CoursesPlanificationWrapper>
  );
};
